function getTrustedOrigins(currentOrigin: string): Set<string> {
  const origins = new Set([currentOrigin]);
  const { hostname } = new URL(currentOrigin);

  if (hostname === "swansonking.com" || hostname === "launch.swansonking.com") {
    origins.add("https://swansonking.com");
    origins.add("https://launch.swansonking.com");
  } else if (
    hostname === "swansonking.localhost" ||
    hostname === "launch.swansonking.localhost"
  ) {
    origins.add("https://swansonking.localhost");
    origins.add("https://launch.swansonking.localhost");
  }

  return origins;
}

export function getSafeAuthCallbackUrl(): string {
  if (typeof window === "undefined") {
    return "/";
  }

  const fallback =
    window.location.pathname === "/workspace" ||
    window.location.pathname.startsWith("/workspace/")
      ? "/workspace"
      : "/";
  const candidate = new URLSearchParams(window.location.search).get(
    "callbackURL",
  );
  if (!candidate) {
    return fallback;
  }

  try {
    const isRelative = candidate.startsWith("/") && !candidate.startsWith("//");
    const url = new URL(candidate, window.location.origin);
    if (
      (!isRelative &&
        !getTrustedOrigins(window.location.origin).has(url.origin)) ||
      url.username ||
      url.password ||
      url.pathname.startsWith("/sign-in")
    ) {
      return fallback;
    }
    return isRelative
      ? `${url.pathname}${url.search}${url.hash}`
      : url.toString();
  } catch {
    return fallback;
  }
}
